import { Component, EventEmitter, Input, Output } from '@angular/core';

/** Panneau replié proposant de basculer vers l'auto-installation. */
@Component({
  selector: 'ng-casto-pose-without-installation',
  templateUrl: './pose-without-installation.component.html',
})
export class PoseWithoutInstallationComponent {
  /** Titre du panneau (HTML autorisé). */
  @Input() title: string;
  /** Émis au clic sur le panneau. */
  @Output() panelClick = new EventEmitter<void>();
  /** Émis au clic sur le bouton de détails. */
  @Output() detailsClick = new EventEmitter<void>();
}
